import { createStore } from 'redux'
import axios from './axios'
import axiosBase from 'axios'
import axiosMetricool from './axiosMetricool'
import { INSIGHT_API_URL } from './constant'

const axiosInsight = axiosBase.create({ baseURL: INSIGHT_API_URL })
axiosInsight.interceptors.request.use((config) => {
  const access_token = localStorage.getItem('access_token')
  if (access_token) config.headers.Authorization = `Bearer ${access_token}`
  return config
})


const initialState = {
  user: null,
  addons: [],
  adsBalance: {},
  campaign: [],
  igManagement: [],
  invoice: [],
  spl: [],
  errorSignin: null,
  globalAlert: {
    enabled: false
  },
  lastCampaignPlan: [],

  metricoolData: {
    profile: null,
    timelines: {
      followers: [],
      reach: [],
      views: [],
    },
    posts: [],
    reels: [],
    stories: [],
    demographics: {
      age: [],
      gender: [],
      city: [],
    },
    competitors: [],
  },
  metricoolLoading: false
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'LOGIN_SUCCESS':
      return { ...state, user: rest.user, errorSignin: null }
    case 'GET_INSIGHT_SUCCESS':
      return { ...state, insight: rest.insight }
    case 'SET_METRICOOL_DATA':
      return {
        ...state,
        metricoolData: rest.data,
        metricoolLoading: false,
      }
    case 'SET_METRICOOL_LOADING':
      return { ...state, metricoolLoading: rest.loading }
    case 'LOGIN_FAILURE':
      return { ...state, user: null, errorSignin: rest.error }
    case 'ERR>400':
      return { ...state, user: null }
    case 'DATA_LOADED':
      const isAllLoaded = state.user && state.adsBalance && state.addons && state.campaign && state.igManagement && state.invoice
      return { ...state, allLoaded: isAllLoaded }
    case 'LOGOUT':
      localStorage.removeItem('access_token')
      return { ...initialState }
    case 'PATCH_ACTIVITY_FEEDBACK':
      const { campaignId, activityId, resultId, feedbacks } = rest
      const campaign = state.campaign.map((c) => {
        if (c.id === campaignId) {
          return {
            ...c,
            activity: c.activity.map((a) => {
              if (a.id === activityId) {
                return {
                  ...a,
                  results: a.results.map((r) => {
                    if (r.id === resultId) {
                      return {
                        ...r,
                        feedbacks,
                      }
                    }
                    return r
                  }),
                }
              }
              return a
            }),
          }
        }
        return c
      })
      return { ...state, campaign }
    case 'SET_ALERT':
      const dispatch = rest
      if (state.globalAlert.enabled) {
        dispatch({
          type: 'CLOSE_ALERT'
        })
      }

      const { severity, title, message } = rest

      return {
        ...state,
        globalAlert: {
          enabled: true,
          severity,
          title,
          message
        }
      }
    case 'CLOSE_ALERT':
      return {
        ...state,
        globalAlert: {
          enabled: false
        }
      }
    case 'SET_STATUS_SPL_APPROVED':
      return {
        ...state,
        spl: state.spl.map((s) => {
          s.status = 'client_approved'
          return s
        })
      }
    case 'SET_STATUS_SPL_REQUESTED_CHANGES':
      return {
        ...state,
        spl: state.spl.map((s) => {
          s.status = 'client_rejected'
          return s
        })
      }
    default:
      return state
  }
}

const store = createStore(changeState)
const handleErr = (e, dispatch, navigate) => {
  // if (!e) {
  //   throw new Error('Unknown error')
  // }
  if (e?.response?.status > 400) {
    dispatch({ type: 'ERR>400' })
    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'error',
      title: 'Error',
      message: 'Something went wrong'
    })
  }
}

export const doGetMetricoolData = async ({ dispatch, getState }, { userId, blogId, from, to }) => {
  try {
    // Set loading FIRST before any async operations
    dispatch({ type: 'SET_METRICOOL_LOADING', loading: true })

    const fromDate = from.startOf('day').format('YYYY-MM-DDTHH:mm:ss')
    const toDate = to.endOf('day').format('YYYY-MM-DDTHH:mm:ss')
    const timezone = 'Asia/Makassar'

    console.log('=== FETCHING METRICOOL DATA ===');
    console.log('From:', fromDate);
    console.log('To:', toDate);
    console.log('Timezone:', timezone);

    const [
      profileRes,
      followersRes,
      reachRes,
      viewsRes,
      postsRes,
      reelsRes,
      storiesRes,
      ageRes,
      genderRes,
      cityRes
    ] = await Promise.all([
      axiosMetricool.get(`/admin/simpleProfiles`, {
        params: { userId, blogId }
      }),

      axiosMetricool.get(`/v2/analytics/timelines`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'followers',
          network: 'instagram',
          timezone,
          subject: 'account',
          userId,
          blogId
        }
      }),

      axiosMetricool.get(`/v2/analytics/timelines`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'reach',
          network: 'instagram',
          timezone,
          subject: 'account',
          userId,
          blogId
        }
      }),

      axiosMetricool.get(`/v2/analytics/timelines`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'views',
          network: 'instagram',
          timezone,
          subject: 'account',
          userId,
          blogId
        }
      }),

      axiosMetricool.get(`/v2/analytics/posts/instagram`, {
        params: { from: fromDate, to: toDate, userId, blogId }
      }),

      axiosMetricool.get(`/v2/analytics/reels/instagram`, {
        params: { from: fromDate, to: toDate, userId, blogId }
      }),

      axiosMetricool.get(`/v2/analytics/stories/instagram`, {
        params: { from: fromDate, to: toDate, userId, blogId }
      }),

      axiosMetricool.get(`/v2/analytics/distribution`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'age',
          network: 'instagram',
          subject: 'account',
          userId,
          blogId
        }
      }),

      axiosMetricool.get(`/v2/analytics/distribution`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'gender',
          network: 'instagram',
          subject: 'account',
          userId,
          blogId
        }
      }),

      axiosMetricool.get(`/v2/analytics/distribution`, {
        params: {
          from: fromDate,
          to: toDate,
          metric: 'city',
          network: 'instagram',
          subject: 'account',
          userId,
          blogId
        }
      })
    ])

    console.log("=== METRICOOL RAW RESPONSES ===");
    console.log("PROFILE:", profileRes.data);
    console.log("FOLLOWERS:", followersRes.data);
    console.log("REACH:", reachRes.data);
    console.log("VIEWS:", viewsRes.data);
    console.log("POSTS:", postsRes.data);
    console.log("REELS:", reelsRes.data);
    console.log("STORIES:", storiesRes.data);
    console.log("AGE:", ageRes.data);
    console.log("GENDER:", genderRes.data);
    console.log("CITY:", cityRes.data);

    console.log("================================");

    // FIX: Sort timeline data chronologically
    const sortTimelineData = (data) => {
      if (!data || !Array.isArray(data)) return [];
      return [...data].sort((a, b) => {
        const dateA = new Date(a.dateTime);
        const dateB = new Date(b.dateTime);
        return dateA - dateB; // Ascending order (oldest first)
      });
    };

    const followersData = followersRes.data?.data?.[0]?.values || [];
    const reachData = reachRes.data?.data?.[0]?.values || [];
    const viewsData = viewsRes.data?.data?.[0]?.values || [];

    console.log('Before sort - Followers sample:', followersData.slice(0, 3).map(v => v.dateTime));

    const sortedFollowers = sortTimelineData(followersData);
    const sortedReach = sortTimelineData(reachData);
    const sortedViews = sortTimelineData(viewsData);

    console.log('After sort - Followers sample:', sortedFollowers.slice(0, 3).map(v => v.dateTime));
    console.log('Total followers data points:', sortedFollowers.length);

    const metricoolData = {
      profile: profileRes.data,
      timelines: {
        followers: sortedFollowers,
        reach: sortedReach,
        views: sortedViews,
      },
      posts: postsRes.data?.data || postsRes.data || [],
      reels: reelsRes.data?.data || reelsRes.data || [],
      stories: storiesRes.data?.data || storiesRes.data || [],
      demographics: {
        age: ageRes.data?.data || [],
        gender: genderRes.data?.data || [],
        city: cityRes.data?.data || [],
      }
    }

    dispatch({ type: 'SET_METRICOOL_DATA', data: metricoolData })

    return metricoolData
  } catch (e) {
    console.error('Error fetching Metricool Data:', e)
    dispatch({ type: 'SET_METRICOOL_LOADING', loading: false })
    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'error',
      title: 'Error',
      message: 'Failed to fetch Metricool data'
    })
  }
}

export const doGetInsightData = async ({ dispatch }, { from, to } = {}) => {
  try {
    dispatch({ type: 'SET_METRICOOL_LOADING', loading: true })

    const params = {}
    if (from) params.from = from.startOf('day').toISOString()
    if (to) params.to = to.endOf('day').toISOString()

    const { data } = await axiosInsight.get('/api/client/insight', { params })

    if (!data) {
      dispatch({ type: 'SET_METRICOOL_LOADING', loading: false })
      return
    }

    // Backend already returns data in Metricool-compatible shape
    const metricoolData = {
      profile: data.profile ?? null,
      timelines: data.timelines ?? { followers: [], reach: [], views: [] },
      posts: data.posts ?? [],
      reels: data.reels ?? [],
      stories: data.stories ?? [],
      demographics: data.demographics ?? { age: [], gender: [], city: [] },
    }

    dispatch({ type: 'SET_METRICOOL_DATA', data: metricoolData })
    return metricoolData
  } catch (e) {
    console.error('Error fetching insight data:', e)
    dispatch({ type: 'SET_METRICOOL_LOADING', loading: false })
    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'error',
      title: 'Error',
      message: 'Failed to fetch insight data',
    })
  }
}

export const doLogin = async (dispatch, identifier, password) => {
  try {
    const { data } = await axios.post('/api/auth/local', { identifier, password })

    localStorage.setItem('access_token', data.jwt)

    return { type: 'LOGIN_SUCCESS', user: data.user }
  } catch (error) {
    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'error',
      title: 'Error',
      message: 'Invalid email or password'
    })
    return { type: 'LOGIN_FAILURE', errorSignin: error.message }
  }
}

export const doGetMe = async ({ dispatch, navigate }) => {
  try {
    const { data } = await axios.get('/api/users/me')
    dispatch({ type: 'LOGIN_SUCCESS', user: data })
  } catch (e) {
    handleErr(e, dispatch, navigate)
  }
}

export const doGetClientSummary = async ({ dispatch, navigate }) => {
  try {
    const { data } = await axios.get('/api/client/summary')
    dispatch({ type: 'set', ...data })
    dispatch({ type: 'DATA_LOADED' })
  } catch (e) {
    handleErr(e, dispatch, navigate)
  }
}

export const doGetInvoiceById = async ({ dispatch, navigate }, { id }) => {
  try {
    const response = await axios({
      url: `/api/client/invoice?id=${id}`,
      method: 'GET',
      responseType: 'blob',
    })

    const href = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', 'invoice.pdf')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  } catch (e) {
    handleErr(e, dispatch, navigate)
  }
}

export const doPatchActivityFeedback = async (
  { dispatch, navigate },
  { campaignId, activityId, resultId, feedbacks },
) => {
  try {
    await axios.patch(`/api/client/activity/feedback`, {
      campaignId,
      activityId,
      resultId,
      feedbacks,
    })

    dispatch({ type: 'PATCH_ACTIVITY_FEEDBACK', campaignId, activityId, resultId, feedbacks })
  } catch (e) {
    handleErr(e, dispatch, navigate)
  }
}

export const doSubmitCampaignPlan = async (
  { dispatch },
  data,
) => {
  try {
    await axios.post(`/api/client/campaign-plan`, data)

    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'success',
      title: 'Success',
      message: 'Plan submitted'

    })
  } catch (e) {
    handleErr(e, dispatch)
  }
}

export const doApproveSPL = async (
  { dispatch },
  data
) => {
  try {
    await axios.post(`/api/client/spl/approve`, data)
    await doGetClientSummary({ dispatch })
    dispatch({ type: 'SET_STATUS_SPL_APPROVED' })

    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'success',
      title: 'Success',
      message: 'Next campaign plan approved'

    })
  } catch (e) {
    handleErr(e, dispatch)
  }
}

export const doRequestChangesSPL = async (
  { dispatch },
  data
) => {
  try {
    await axios.post(`/api/client/spl/request-changes`, data)
    dispatch({ type: 'SET_STATUS_SPL_REQUESTED_CHANGES' })
    await doGetClientSummary({ dispatch })

    dispatch({
      type: 'SET_ALERT',
      dispatch,
      severity: 'success',
      title: 'Success',
      message: 'SPL changes requested'

    })
  } catch (e) {
    handleErr(e, dispatch)
  }
}

export default store
